module.exports = __webpack_public_path__ + "img/2.13da3aba.jpg";